__turbopack_context__.v({
  "icon": "jk1o-a_icon",
  "scrollToTopButton": "jk1o-a_scrollToTopButton",
});
